<template>
    <app-content-admin>
        <template slot="header">Add Project</template>
               
        <v-layout row wrap>

<v-flex xs12 lg6 mx-auto>
    <v-card>
        <v-card-text>           
            <v-container fluid grid-list-xs>
                <v-layout wrap>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project name')"
                            v-model="form.firebase_project_name"
                            :rules="[rules.required('Firebase project name')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project id')"
                            v-model="form.firebase_project_id"
                            :rules="[rules.required('Firebase project id')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Firebase project number')"
                            v-model="form.firebase_project_number"
                            :rules="[rules.required('Firebase project number')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-file-input
                            :label="$t('Firebase service account (json file)')"
                            :rules="[rules.required('Firebase service account')]"
                            v-model="jsonFile"
                            outlined
                            accept=".json"
                        >
                        </v-file-input>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="createProject"
                class="form-submit"
            >
                Submit
            </v-btn>
        </v-card-actions>
    </v-card>

</v-flex>

</v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'


export default {
    mixins: [vForm],

    data(){
        return {     
            jsonFile:null,
            form: {
                // firebase_project_name: "test",
                // firebase_project_id: "test-d87c9",
                // firebase_project_number:'656890956246',
                // firebase_service_account:'test-d87c9-firebase-adminsdk-vtxcr-7579150601.json'
                firebase_project_name: null,
                firebase_project_id: null,
                firebase_project_number:null,
                firebase_service_account:null
            }                     
          }
        },

        components: {ActiveLabel},

        created() {
        },

        methods: {
            async createProject(){
                let loader = this.$loading.show();
                try{
                let path = await this.uploadJSON();
                console.log(path)
                this.form.firebase_service_account = path;
                let token = store.getters['auth/token'];
                let res = await axios.post(`/api/cloud/create_firebase_project?token=${token}`,this.form)
                     if(res.status == 200){
                        this.$toastr.s('New project created successfully');  
                        this.$router.push('/template/add_template')   
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                  
                }
            },

            async uploadJSON(){
                var formData = new FormData();
                formData.append('firebase_service_account',this.jsonFile)
                try{
                let token = store.getters['auth/token'];
                const config = {
                   headers:{
                       'Content-Type' : 'multipart/form-data',
                   }
                 };
                let res = await axios.post(`/api/cloud/upload_json?token=${token}`,formData, config)
                return res.data.data.path                   
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }                
            },
            fileChange(e){
                this.jsonFile = e;
            },         

        }
}
</script>